export const getResponseApi = (prompt_uid) =>
    fetch(`/api/v1/ai-prompts/${prompt_uid}/raw-responses/`, {
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });

export const fetchHtml = (url) =>
    fetch(url, {
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': window.csrf_token,
        },
    });
